import { Content } from "antd/es/layout/layout";
import { FC, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackgroundSVGs from "../../../components/auth/layout/BackgroundSVGs";
import { Flex, message } from "antd";
import LookFindrLogo from "../../../assets/images/LookfindrLogo";
import AuthTitleAndDescription from "../../../components/auth/AuthTitleAndDescription";
import LoginWithOTP from "../../../components/auth/loginWithOTP/LoginWithOTP";
import { sendOTP, verifyOTP } from "../../../network/auth";
import { setUserData } from "../../../services/store/slices/user";
import { useDispatch } from "react-redux";
import useGetUserData from "../../../hooks/useGetUserData";
import { useIntl } from "react-intl";

interface TMLoginProps {}

const TMLogin: FC<TMLoginProps> = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useGetUserData();
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);
  if (isLoggedIn) return null;

  const onLoginSuccess = (res: any) => {
    console.log(res);
    if (res?.code !== "ERR_BAD_REQUEST" && res?.code !== "ERR_BAD_RESPONSE") {
      const userData = res?.data?.data;
      if (userData?.token) {
        const isAdmin = userData?.user?.roles?.some(
          (s: any) => s?.name === "admin"
        );
        const isSalonOwner = userData?.user?.roles?.some(
          (s: any) => s?.name === "salon_owner"
        );
        const isTeamMember = userData?.user?.roles?.some(
          (s: any) => s?.name === "team_member"
        );
        localStorage.setItem("token", userData?.token);
        dispatch(setUserData(userData));
        if (isSalonOwner) {
          if (userData?.user?.salon) {
            message.success(intl.formatMessage({ id: "loginSuccess" }));
            navigate("/");
          } else {
            message.success(
              intl.formatMessage({ id: "mustCompleteSalonInfo" })
            );
            navigate("/onBoarding");
          }
        } else if (isAdmin) {
          navigate("/");
        } else if (isTeamMember) {
          navigate("/");
        }
      }
    } else {
      message.error(intl.formatMessage({ id: "emailOrPasswordIsWrong" }));
    }
  };
  return (
    <Content className="bg-white  ">
      <BackgroundSVGs />
      <Flex
        justify="center"
        align="center"
        style={{
          minHeight: "100vh",
        }}
        // className="pt-[20px]  "
      >
        <div
          className="w-[338px]  md:w-[680px]   my-2 shadow-full relative bg-white
              px-[16px] md:px-[60px] py-[32px] sm:py-[40px]  rounded-[12px] "
        >
          <Flex vertical gap={"20px"} className="relative ">
            <Flex justify="center" align="center">
              <LookFindrLogo
                onClick={() => {
                  navigate("/register");
                }}
              />
            </Flex>
            <AuthTitleAndDescription
              titleAndDescription={{
                title: intl.formatMessage({ id: "welcomeLookfindr" }),
                description: intl.formatMessage({ id: "idealSolution" }),
              }}
            />
            {/* <Oauth /> */}
            {/* <Divider className="w-[172px]   md:w-[512px] m-auto bg-[#9CABC2]" /> */}
            <div className=" text-center ">
              <div className="h-[1px]   m-auto bg-[#9CABC2] "></div>
            </div>
            <div className="flex flex-col gap-4 justify-center items-center">
              <h4 className="text-color-primary text-xl ">
                {intl.formatMessage({ id: "welcomeBackLogin" })}
              </h4>
              <p className="text-color-sec-title">
                {intl.formatMessage({ id: "completeTheFollowing" })}
              </p>
            </div>
            <LoginWithOTP
              login={sendOTP}
              sendOTP={sendOTP}
              verifyOTP={verifyOTP}
              onLoginSuccess={onLoginSuccess}
            />
          </Flex>
          <Flex justify="center" className="">
            <p className="text-sec-title text-center text-base ">
              {intl.formatMessage({ id: "newUser" })}
              <Link
                className="text-txt-link font-semibold !underline !underline-offset-[6px]"
                to="/register"
              >
                {intl.formatMessage({ id: "registerWithLookfindr" })}
              </Link>
            </p>
          </Flex>
        </div>
      </Flex>
    </Content>
  );
};

export default TMLogin;
